var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-select',{attrs:{"items":_vm.langs,"solo":"","dense":""},on:{"change":_vm.changeLocale},model:{value:(_vm.$i18n.locale),callback:function ($$v) {_vm.$set(_vm.$i18n, "locale", $$v)},expression:"$i18n.locale"}})
}
var staticRenderFns = []

export { render, staticRenderFns }